import React, { useEffect, useState } from "react";

const ENTRIES = [
  {
    id: "2025-journeys",
    title: "Journey System & Personalisation Platform",
    org: "The LEGO Group",
    start: "Mar 2025",
    end: "Present",
    summary:
      "Co-designed journey infrastructure on a scalable middle layer with robust event flows.",
    tags: ["Tech", "Leadership", "Impact"],
  },
  {
    id: "2024-audiences",
    title: "Audiences Feature Set & Consent RFC",
    org: "The LEGO Group",
    start: "Feb 2024",
    end: "Dec 2024",
    summary:
      "Delivered Audiences (bulk upload, ingestion, dedupe). Authored consent migration RFC.",
    tags: ["Tech", "Leadership", "Impact"],
  },
  {
    id: "2023-cdp",
    title: "CDP Middle Layer & Event Integration",
    org: "The LEGO Group",
    start: "Feb 2023",
    end: "Dec 2023",
    summary:
      "Owned CDP integration during reduced capacity. Built a scalable event-driven middle layer.",
    tags: ["Tech", "Impact", "Leadership"],
  },
];

export default function Timeline() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") setActive((i) => Math.min(i + 1, ENTRIES.length - 1));
      if (e.key === "ArrowLeft") setActive((i) => Math.max(i - 1, 0));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const current = ENTRIES[active];

  return (
    <div className="timeline">
      <aside className="rail">
        {ENTRIES.map((e, i) => (
          <button
            key={e.id}
            className={`node ${i === active ? "active" : ""}`}
            onClick={() => setActive(i)}
          >
            <span className="date">{e.start} – {e.end || "Present"}</span>
            <span className="title">{e.title}</span>
            <span className="org">{e.org}</span>
          </button>
        ))}
      </aside>

      <section className="detail">
        <h2>{current.title}</h2>
        <div className="meta">
          <span>{current.org}</span> • <span>{current.start} – {current.end || "Present"}</span>
        </div>
        <p className="summary">{current.summary}</p>
        <div className="tags">
          {current.tags.map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
        <div className="hint">Use ← / → to navigate</div>
      </section>
    </div>
  );
}
